import { Stack } from "@mui/material";
import { FileIcon } from "../../images";
import { ReuseEllipsisTooltip } from "../ReuseEllipsisTooltip";

type Props = {
  fileName: string;
};

export const FileListItem = ({ fileName }: Props) => {
  return (
    <Stack direction="row" alignItems="center" gap="10px">
      <FileIcon width="24" height="24" color={"#1C3C6C"} />

      <ReuseEllipsisTooltip tooltip={fileName}>{fileName}</ReuseEllipsisTooltip>
    </Stack>
  );
};
